import { cn } from "@/lib/utils";

/** Plitalar palitrasidan barqaror rang: bir odam har joyda bir xil rangda. */
const GRADIENTS = [
  "from-tile-coral-strong to-tile-amber-strong",
  "from-tile-sky-strong to-tile-violet-strong",
  "from-tile-mint-strong to-tile-sky-strong",
  "from-tile-violet-strong to-tile-coral-strong",
  "from-tile-amber-strong to-tile-mint-strong",
];

export function avatarGradient(seed: string): string {
  let hash = 0;
  for (const char of seed) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return GRADIENTS[hash % GRADIENTS.length] ?? GRADIENTS[0];
}

export function initialsOf(name: string): string {
  const letters = name
    .replace(/^@/, "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() ?? "")
    .join("");
  return letters || "?";
}

export function UserAvatar({
  name,
  seed,
  className,
}: {
  name: string;
  seed: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "text-card grid size-9 shrink-0 place-items-center rounded-xl bg-gradient-to-br text-xs font-semibold shadow-sm",
        avatarGradient(seed),
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
